/**
 * API de Aperturas de Inventario (inventoryOpening.php)
 * CRUD: listar, obtener por ID, estados, crear, actualizar, confirmar, cancelar
 */

import { dotoniwoofApi } from '../api/dotoniwooApi';

const BASE = '/inventoryOpening.php';

/**
 * GET / - Listar aperturas (paginado, con filtros)
 * @param {Object} params - { date_from, date_to, id_status, page, limit }
 */
export const getOpeningList = async (params = {}) => {
  try {
    const response = await dotoniwoofApi.get(BASE, { params });
    const data = response.data;
    return {
      ok: true,
      status: response.status,
      code: data?.code,
      total_rows: data?.total_rows ?? 0,
      total_pages: data?.total_pages ?? 1,
      page: data?.page ?? 1,
      data: data?.data ?? []
    };
  } catch (error) {
    console.error('Error al listar aperturas:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * GET /{id} - Obtener una apertura con sus detalles
 */
export const getOpeningById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`${BASE}/${id}`);
    const data = response.data;
    return {
      ok: true,
      status: response.status,
      data: data?.data ?? data
    };
  } catch (error) {
    console.error('Error al obtener apertura:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * GET /statuses - Listar estados (BORRADOR, CONFIRMADO, CANCELADO)
 */
export const getOpeningStatuses = async () => {
  try {
    const response = await dotoniwoofApi.get(`${BASE}/statuses`);
    const data = response.data;
    return {
      ok: true,
      status: response.status,
      data: data?.data ?? []
    };
  } catch (error) {
    console.error('Error al obtener estados:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * POST / - Crear apertura
 * @param {Object} payload - { firebase_UID, open_date, id_status?, notes?, details }
 */
export const createOpening = async (payload) => {
  try {
    const response = await dotoniwoofApi.post(BASE, payload);
    const data = response.data;
    return {
      ok: true,
      status: response.status,
      code: data?.code,
      id_opening: data?.id_opening,
      message: data?.message,
      data
    };
  } catch (error) {
    console.error('Error al crear apertura:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al crear apertura' }
    };
  }
};

/**
 * PUT /{id} - Actualizar apertura (solo BORRADOR)
 * @param {number} id - id_opening
 * @param {Object} payload - { firebase_UID, open_date?, notes?, details }
 */
export const updateOpening = async (id, payload) => {
  try {
    const response = await dotoniwoofApi.put(`${BASE}/${id}`, payload);
    const data = response.data;
    return {
      ok: true,
      status: response.status,
      code: data?.code,
      data
    };
  } catch (error) {
    console.error('Error al actualizar apertura:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al actualizar apertura' }
    };
  }
};

/**
 * PUT /{id}/confirm - Confirmar apertura en BORRADOR
 * @param {number} id - id_opening
 * @param {string} firebase_UID
 */
export const confirmOpening = async (id, firebase_UID) => {
  try {
    const response = await dotoniwoofApi.put(`${BASE}/${id}/confirm`, { firebase_UID });
    const data = response.data;
    return {
      ok: true,
      status: response.status,
      code: data?.code,
      data
    };
  } catch (error) {
    console.error('Error al confirmar apertura:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al confirmar apertura' }
    };
  }
};

/**
 * DELETE /{id} - Cancelar apertura (revertir stock)
 * @param {number} id - id_opening
 * @param {string} firebase_UID
 */
export const cancelOpening = async (id, firebase_UID) => {
  try {
    const response = await dotoniwoofApi.delete(`${BASE}/${id}`, {
      data: { firebase_UID }
    });
    const data = response.data;
    return {
      ok: true,
      status: response.status,
      code: data?.code,
      data
    };
  } catch (error) {
    console.error('Error al cancelar apertura:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al cancelar apertura' }
    };
  }
};
